// extracted by mini-css-extract-plugin
module.exports = {"private":"private___3Mdok","checkbox":"checkbox___qeqje","checkmark":"checkmark___3dihy","agree":"agree___39KMA","ja":"ja___32Nr7","link":"link___3e4f4","zh":"zh___nWSx4"};